import React from 'react'
import { Link } from 'react-router-dom'
import { withNamespaces } from 'react-i18next'

export const Footer = props => {
	const { t } = props
	return <footer className='c-footer u-bg--black'>
		<div className='o-layout u-padding-vertical u-padding-vertical-large@tablet u-padding-vertical-huge@desktop u-border-bottom--white-20'>
			<div className='o-wrapper u-flex u-flex--align--start'>
				<div className='o-layout__item u-1/1 u-1/4@tablet u-margin-bottom u-margin-bottom-none@tablet u-center-on-mobile'>
					<Link to={'/'} className='u-flex u-flex--align--baseline'>
						<img src='/img/logo.svg' alt='ZHK Jura Logo'/>
						<span className='u-text--white u-margin-left-small u-text--normal'>{t('general.siteName')}</span>
					</Link>
				</div>
				<div className='o-layout__item u-1/1 u-1/4@tablet u-margin-bottom-small u-margin-bottom-none@tablet u-center-on-mobile'>
					<h3 className='u-text--bud u-margin-bottom-tiny u-weight--normal'>{t('footer.phone')}</h3>
					<div><a href='tel:+359885620065' className='u-text--white u-text--normal'>+359 885 620 065</a></div>
				</div>
				<div className='o-layout__item u-1/1 u-1/4@tablet u-margin-bottom-small u-margin-bottom-none@tablet u-center-on-mobile'>
					<h3 className='u-text--bud u-margin-bottom-tiny u-weight--normal'>{t('footer.email')}</h3>
					<a href='mailto:info@jurabg.com' className='u-text--white u-text--normal'>info@jurabg.com</a>
				</div>
				<div className='o-layout__item u-1/1 u-1/4@tablet u-center-on-mobile'>
					<h3 className='u-text--bud u-margin-bottom-tiny u-weight--normal'>{t('footer.address')}</h3>
					<a href='https://www.google.bg/maps/place/9010+%D0%B6.%D0%BA.+%D0%91%D1%80%D0%B8%D0%B7,+Varna/@43.2214843,27.9340169,14z/data=!3m1!4b1!4m5!3m4!1s0x40a45426a5760911:0x2cf1397de18bd121!8m2!3d43.2222008!4d27.955466' className='u-text--white'>{t('footer.addressLinkText')}</a>
				</div>
			</div>
		</div>
		<div className='o-layout u-padding-top u-padding-bottom'>
			<div className='o-wrapper'>
				<div className='o-layout__item u-1/1 u-center-on-mobile'>
					<span className='u-text--white'>{t('general.siteName')}</span>
					<span className='u-text--finch u-weight--bold u-margin-left-tiny'>© 2021 Jura RESIDENCE. All rights reserved.</span>
				</div>
			</div>
		</div>
	</footer>
}

export default withNamespaces()(Footer)



// WEBPACK FOOTER //
// ./src/components/Footer.js